import { NgStyle } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GetAccountRequests } from '@app/finxone-web-frontend/app/lib/actions/savings-account.action';
import { SafeHtmlPipe } from '@app/finxone-web-frontend/app/lib/pipes/SafeHtml.pipe';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { SavingsAccountService } from '@app/finxone-web-frontend/app/lib/services/savings-account-service/savings-account.service';
import { AccountOpenRequestType } from '@app/finxone-web-frontend/app/lib/services/savings-account-service/savings-account.type';
import { SavingsAccountState } from '@app/finxone-web-frontend/app/lib/state/savings-account.state';
import { buildHandleBarModel } from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { AlertHandlerService, IconCacheService } from '@finxone-platform/shared/services';
import {
  APP_ZONES,
  BaseCssProperties,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
  baseCssConfigStyle,
  formatNameAsUrl,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import { Subject, takeUntil } from 'rxjs';

const defaultTemplate = `<button class="buttonPrimary">{{ accountRequest.status }}</button>`;

@Component({
  selector: 'finxone-web-frontend-account-request-list',
  templateUrl: './account-request-list.component.html',
  imports: [NgStyle, SafeHtmlPipe],
})
export class AccountRequestListComponent implements OnInit {
  @AutoDestroy private destroy$: Subject<void> = new Subject<void>();
  public accountRequests: AccountOpenRequestType[] = [];
  public baseHandleBarModel: any;
  public templateFunction: HandlebarsTemplateDelegate<any>;
  public widgetStyle: baseCssConfigStyle;
  public listDirection: 'column' | 'row' = 'column';
  constructor(
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    public store: Store,
    public configService: ConfigService,
    public savingsAccountService: SavingsAccountService,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private iconCacheService: IconCacheService,
    private router: Router,
    private alertHandlerService: AlertHandlerService,
  ) {}

  ngOnInit(): void {
    if (this.dataIn?.attri) {
      this.templateFunction = Handlebars.compile(
        this.dataIn.attri.widgetProperties?.textContent || defaultTemplate,
      );
      this.listDirection =
        this.dataIn.attri.widgetProperties?.['listDirection'] === 'horizontal' ? 'row' : 'column';
      this.widgetStyle = this.configService.getSpecificBaseCssStyle(this.dataIn?.attri, [
        BaseCssProperties.MARGIN,
        BaseCssProperties.PADDING,
        BaseCssProperties.BORDER_V2,
      ]);
    }

    this.store
      .dispatch(new GetAccountRequests())
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.store
          .select(SavingsAccountState.getAccountRequests)
          .pipe(takeUntil(this.destroy$))
          .subscribe((accountRequests) => {
            if (accountRequests) this.accountRequests = accountRequests;
          });
      });

    buildHandleBarModel(this.store, '', this.countriesCurrenciesService, this.iconCacheService)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.baseHandleBarModel = model;
      });
  }

  public createItemTemplate(request: AccountOpenRequestType): string {
    return this.templateFunction({
      accountRequest: request,
      ...this.baseHandleBarModel,
    });
  }

  public onRequestClick(requestId: string): void {
    this.savingsAccountService.getAccountRequestToken(requestId).subscribe((response) => {
      if (response.status === 'manual-review') {
        this.alertHandlerService.showAlertFn(
          'success',
          `No need for you to do anything. We will notify you once the review is complete.`, // message
          'Your application is under review by our team. ', // header
        );

        // findAndShowAlertFromCode(this.store, this.router, this.alertHandlerService, [
        //   OpenAccountRequestWarningCodes.UNDER_REVIEW,
        // ]);
      } else {
        const token = response.sumsubAccessToken;
        const nextRoute = `/zones/${formatNameAsUrl(APP_ZONES.LANDING)}/sumsub?sumsubAccessToken=${token}`;
        this.router.navigateByUrl(nextRoute);
      }
    });
  }
}
